module.exports = __webpack_public_path__ + "static/img/card2.db945946.png";